import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, ContentChildren, QueryList } from '@angular/core';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { StorageService } from '@toro/common/shared/services/storage.service';

@Component({
  selector: 'success-action-result',
  templateUrl: './success-action-result.component.html',
  styleUrls: ['./success-action-result.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SuccessActionResultComponent extends DialogFullScreenComponentContent {

  public bookingIcon = 'waiting';

  constructor(
    private dialogReference: MatDialogRef<SuccessActionResultComponent>,
    public element: ElementRef,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string,
      message: string,
      booked: boolean,
      icon: string,
  }) {
      super(element);
  }

  public dispose() {
    super.close(this.dialogReference, null);
  }

  public onCloseRequestHandler() {
   // Handler
  }
}
